<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('autoRents.title') }} - {{ autoTitle }}
          </h1>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <!-- Auto rents table -->
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12>
              <v-data-table
                id="autoRents"
                :items="autoRents.items"
                :headers="headers"
                :loading="isLoading"
                :loading-text="$t('common.table.dataIsLoading')"
                :server-items-length="2"
                :mobile-breakpoint="100"
                class="table-custom autoRents small mb-4"
                hide-default-footer
              >
                <template slot="item" slot-scope="{ item }">
                  <tr
                    :key="item.id"
                    :class="{
                      canceled:
                        item.statusId === 3 ||
                        item.statusId === 4 ||
                        item.statusId === 5,
                      finished: item.statusId === 2,
                    }"
                    @click="goToRentPage(item.id)"
                  >
                    <td>{{ item.num }}</td>
                    <td class="text-xs-left">{{ item.id }}</td>
                    <td class="text-xs-left">
                      <v-icon
                        v-if="item.isDefect"
                        color="#df2323"
                        class="svg-icon mr-2"
                      >
                        warning
                      </v-icon>
                      <span>{{ item.name }}</span>
                    </td>
                    <td class="text-xs-left">
                      <div>{{ item.phone }}</div>
                      <div>{{ item.secondPhone }}</div>
                    </td>
                    <td class="text-xs-left">
                      <div>{{ item.date }}</div>
                      <div>{{ item.type }}</div>
                    </td>
                    <td class="text-xs-left">{{ item.price }}</td>
                    <td class="text-xs-left">{{ item.status }}</td>
                  </tr>
                </template>
                <template slot="no-data">{{
                  $t('common.table.noData')
                }}</template>
              </v-data-table>
              <div v-if="paginationPage" class="text-xs-center">
                <v-pagination
                  :value="paginationPage"
                  :length="paginationLength"
                  @input="choosePaginatorPage($event)"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import store from '@/store';
import hasPermission from '@/helpers/hasPermission';

export default {
  name: 'AutoRentsPage',
  components: {},
  beforeRouteEnter(to, from, next) {
    const isInvestor = store.getters['global/getRole'] === 'investor';
    if (!isInvestor || hasPermission('investor_car_rent_history')) next();
  },
  data() {
    return {
      dataIsLoading: false,
      headers: [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('autoRents.tableHeaders.id'), sortable: false },
        { text: this.$t('autoRents.tableHeaders.name'), sortable: false },
        { text: this.$t('autoRents.tableHeaders.phone'), sortable: false },
        {
          text: this.$t('autoRents.tableHeaders.dateAndShift'),
          sortable: false,
        },
        { text: this.$t('autoRents.tableHeaders.price'), sortable: false },
        { text: this.$t('autoRents.tableHeaders.status'), sortable: false },
      ],
    };
  },
  watch: {
    /* eslint-disable */
    '$i18n.locale': async function() {
      await this.fetchAutoRents({
        page: this.paginationPage,
        autoId: this.$route.params.autoId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
  },
  computed: {
    ...mapGetters({
      autoTitle: 'auto/getAutoTitle',
      isLoading: 'global/getLoader',
      autoRents: 'auto/getAutoRentsData',
    }),
    paginationLength() {
      return this.autoRents.lastPage;
    },
    paginationPage() {
      if (this.autoRents.currentPage === 1 && this.autoRents.lastPage === 1) {
        return 0;
      }
      return this.autoRents.currentPage;
    },
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchAutoRents({
        page: 1,
        autoId: this.$route.params.autoId,
      });
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.setAutoRentsData({});
  },
  methods: {
    ...mapActions({
      fetchAutoRents: 'auto/fetchAutoRentsData',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      setAutoRentsData: 'auto/setAutoRentsData',
    }),
    async choosePaginatorPage(page) {
      await this.fetchAutoRents({
        page,
        autoId: this.$route.params.autoId,
      });
      this.$vuetify.goTo(0, 'easeInOutCubic');
    },
    goToRentPage(rentId) {
      this.$router.push(`/rents/${rentId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.canceled {
  background: rgba(233, 30, 30, 0.25);
}
.finished {
  background: rgba(227, 224, 224, 0.25);
  color: #808080;
}
</style>
